var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('i',{staticClass:"mr-1 flaticon-power-button"}),_c('span',[_vm._v("تسجيل الخروج")])])
}
var staticRenderFns = []

export { render, staticRenderFns }